module.exports = __webpack_public_path__ + "c5cd7f53.gif";